import Vue from 'vue'

class Repository {
	client = () => Vue.prototype.$api

	constructor (path) {
		this.path = path
	}

	getAll (criteria = {}, config = {}) {
		return this.client().get(`/${this.path}`, { params: criteria, ...config })
	}

	get (id, config = {}) {
		return this.client().get(`/${this.path}/${id}`, config)
	}

	post (data, config = {}) {
		return this.client().post(`/${this.path}`, data, config)
	}

	put (id, data, config = {}) {
		return this.client().put(`/${this.path}/${id}`, data, config)
	}

	delete (id, config = {}) {
		return this.client().delete(`/${this.path}/${id}`, config)
	}
}

export default Repository


// WEBPACK FOOTER //
// ./src/repositories/Repository.js